import PostsPagePersonalArea from './PostsPagePersonalArea';

export default PostsPagePersonalArea;
